import React from 'react';
import { MapPin, CheckCircle, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 overflow-hidden" data-id="element-74">
      {/* Parallax Background */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/5bgm1rSa4zH98cuiNEJwvS/petar-tonchev-c-5-QE5kBYk-unsplash.jpg")',
      backgroundAttachment: 'fixed',
      backgroundPosition: 'center center'
    }} data-id="element-75" />

      {/* Dark Overlay for text legibility */}
      <div className="absolute inset-0 z-10 bg-black/50" data-id="element-76" />
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/40 via-black/20 to-black/60" data-id="element-77" />

      <div className="container relative z-20 mx-auto px-6 max-w-4xl text-center flex flex-col items-center" data-id="element-78">
        <h1 className="font-heading font-bold text-white text-4xl md:text-5xl lg:text-6xl leading-tight mb-6 drop-shadow-lg" data-id="element-79">
          Denton's Favorite Lawn and Landscape Crew
        </h1>

        <p className="text-white text-lg md:text-xl lg:text-2xl mb-10 max-w-2xl drop-shadow-md font-medium" data-id="element-80">
          From fresh sod to custom hardscaping, we make Denton yards the best on
          the block.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto mb-16" data-id="element-81">
          <a href="#quote" className="w-full sm:w-auto bg-brand hover:bg-brand-light text-white font-semibold py-4 px-8 rounded-xl transition-colors min-h-[48px] flex items-center justify-center text-lg" data-id="element-82">
            Get a Free Quote
          </a>
          <a href="#work" className="w-full sm:w-auto bg-white border-2 border-white hover:bg-gray-100 text-brand font-semibold py-4 px-8 rounded-xl transition-colors min-h-[48px] flex items-center justify-center text-lg" data-id="element-83">
            See Our Work
          </a>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 text-white drop-shadow-md" data-id="element-84">
          <div className="flex items-center gap-2" data-id="element-85">
            <MapPin className="text-brand-light" size={24} data-id="element-86" />
            <span className="font-semibold" data-id="element-87">Locally Owned</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-88">
            <CheckCircle className="text-brand-light" size={24} data-id="element-89" />
            <span className="font-semibold" data-id="element-90">Free Estimates</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-91">
            <div className="flex -space-x-1" data-id="element-92">
              {[...Array(5)].map((_, i) => <Star key={i} className="text-yellow-400 fill-yellow-400" size={20} data-id="element-93" />)}
            </div>
            <span className="font-semibold ml-1" data-id="element-94">5-Star Rated</span>
          </div>
        </div>
      </div>
    </section>;
}